import levels, { isLevelActive } from './util/levels';
import levelLog from './util/levelLog';
import createScribeLogger from './util/createScribeLogger';
import { isLogLevelName } from './util/convertStringToLogLevelName';
const defaultOpts = {
    logToConsole: process.env.NODE_ENV !== 'production',
};
const createLogger = (appName, options = {}) => {
    const { name: optName, logToConsole, scribeUrl, sessionId, context: optContext, } = {
        ...defaultOpts,
        ...options,
    };
    const targetLevel = options.logLevel || process.env.NODE_ENV === 'production' ? 'info' : 'trace';
    const context = optContext || {};
    const liveContext = {};
    const name = optName || '';
    const scribe = scribeUrl ? createScribeLogger(scribeUrl) : undefined;
    // default to info if not set
    const scribeTargetLevel = isLogLevelName(process.env.REACT_APP_SCRIBE_TARGET_LEVEL)
        ? process.env.REACT_APP_SCRIBE_TARGET_LEVEL
        : 'info';
    const levelLoggers = levels.reduce((result, level) => ({
        ...result,
        [level.name]: (...args) => levelLog({
            appName,
            level,
            name,
            logToConsole,
            scribe,
            sessionId,
            targetLevel,
            scribeTargetLevel,
            context,
            liveContext,
            args,
        }),
    }), {});
    return {
        extend: (extendedName) => {
            return createLogger(appName, { ...options, name: extendedName, context });
        },
        setContextValue: (key, value) => {
            if (typeof value === 'function') {
                liveContext[key] = value;
            }
            else {
                context[key] = value;
            }
        },
        removeContextValue: (key) => delete context[key],
        trace: levelLoggers.trace,
        isTrace: () => isLevelActive('trace', targetLevel),
        debug: levelLoggers.debug,
        isDebug: () => isLevelActive('debug', targetLevel),
        info: levelLoggers.info,
        isInfo: () => isLevelActive('info', targetLevel),
        warn: levelLoggers.warn,
        isWarn: () => isLevelActive('warn', targetLevel),
        error: levelLoggers.error,
        isError: () => isLevelActive('error', targetLevel),
    };
};
export default createLogger;
//# sourceMappingURL=createLogger.js.map